import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ModalType } from './types';

type ModalTypeState = {
    type: ModalType | null;
};

const initialState: ModalTypeState = {
    type: null,
};

const modalTypeSlice = createSlice({
    name: 'dtmf-modal-type',
    initialState,
    reducers: {
        setModalType(state: ModalTypeState, action: PayloadAction<ModalType | null>) {
            state.type = action.payload;
        },
    },
});

export const modalTypeReducer = modalTypeSlice.reducer;
export const { setModalType } = modalTypeSlice.actions;
